 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import EVEOFWARFARECOVER from '@/components/eveofwarfarecover'
 import EVEOFWARFAREPRAISE from '@/components/eveofwarfarepraise'
 import EVEOFWARFAREBOOKS from '@/components/eveofwarfarebooks'
 import EVEOFWARFARETP from '@/components/eveofwarfaretp'
 import EVEOFWARFARE1 from '@/components/eveofwarfare1'
 import EVEOFWARFARETOC from '@/components/eveofwarfaretoc'
 import EVEOFWARFARE2 from '@/components/eveofwarfare2'
 import EVEOFWARFARE3 from '@/components/eveofwarfare3'
 import EVEOFWARFARE4 from '@/components/eveofwarfare4'
 import EVEOFWARFARE5 from '@/components/eveofwarfare5'
 import EVEOFWARFARE6 from '@/components/eveofwarfare6'
 import EVEOFWARFARE7 from '@/components/eveofwarfare7'
 import EVEOFWARFARE7B from '@/components/eveofwarfare7b'
 import EVEOFWARFARE8 from '@/components/eveofwarfare8'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/eveofwarfarecover",
 			"name" : "eveofwarfarecover",
 			"component" : EVEOFWARFARECOVER
 		},
 		{
 			"path" : "/eveofwarfarepraise",
 			"name" : "eveofwarfarepraise",
 			"component" : EVEOFWARFAREPRAISE
 		},
 		{
 			"path" : "/eveofwarfarebooks",
 			"name" : "eveofwarfarebooks",
 			"component" : EVEOFWARFAREBOOKS
 		},
 		{
 			"path" : "/eveofwarfaretp",
 			"name" : "eveofwarfaretp",
 			"component" : EVEOFWARFARETP
 		},
 		{
 			"path" : "/eveofwarfare1",
 			"name" : "eveofwarfare1",
 			"component" : EVEOFWARFARE1
 		},
 		{
 			"path" : "/eveofwarfaretoc",
 			"name" : "eveofwarfaretoc",
 			"component" : EVEOFWARFARETOC
 		},
 		{
 			"path" : "/eveofwarfare2",
 			"name" : "eveofwarfare2",
 			"component" : EVEOFWARFARE2
 		},
 		{
 			"path" : "/eveofwarfare3",
 			"name" : "eveofwarfare3",
 			"component" : EVEOFWARFARE3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js